import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const StyledWrapper = styled.div.withConfig({ displayName: "StyledWrapper", componentId: "-1t4nwpq" }) `
  background-color: ${(props) => props.theme.colors.darkEclipse};
  padding: ${(props) => props.theme.spacers.xxxl} 0;
`;
export const StyledHeading = styled.h2.withConfig({ displayName: "StyledHeading", componentId: "-18mphnm" }) `
  font-size: 18px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.white};
  margin: 0 0 ${(props) => props.theme.spacers.medium};
`;
export const StyledParagraph = styled.p.withConfig({ displayName: "StyledParagraph", componentId: "-kju89s" }) `
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  margin: 0 0 ${(props) => props.theme.spacers.medium};
`;
export const StyledLink = styled(Link).withConfig({ displayName: "StyledLink", componentId: "-1kr6pcv" }) `
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;
export const StyledList = styled.ul.withConfig({ displayName: "StyledList", componentId: "-bnxxxm" }) `
  list-style: none;
  margin: 0;
  padding: 0;
`;
export const StyledListItem = styled.li.withConfig({ displayName: "StyledListItem", componentId: "-dpqntc" }) `
  margin: 0 0 ${(props) => props.theme.spacers.small};
  line-height: 18px;
`;
export const StyledCopyright = styled.p.withConfig({ displayName: "StyledCopyright", componentId: "-520upl" }) `
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};
  margin: 50px 0 0;
`;
